import type { FaqDto, FaqListDto } from './dto';
import type { FaqForm, FaqItem } from './types';

export function toFaqItem(dto: FaqDto): FaqItem {
    return {
        id: dto.id,
        question: dto.name?.trim() ?? 'Без заголовка',
        answer: dto.content?.trim() ?? '',
        images: Array.isArray(dto.file_links) ? dto.file_links.filter(Boolean) : [],
    };
}

export function toFaqList(dto: FaqListDto): FaqItem[] {
    return Array.isArray(dto?.data) ? dto.data.map(toFaqItem) : [];
}

export function toFaqBody(form: FaqForm): FormData {
    const body = new FormData();
    body.append('name', form.question.trim());
    body.append('content', form.answer.trim());
    if (form.file) body.append('files', form.file);
    return body;
}